<template>
  <div class="analyze-container">
    <analyze-item v-for="(item,index) in analyzeData" :key="index" :data="item" :index="++index"></analyze-item>
    <div v-if="analyzeData.length === 0" class="nodata">暂无数据</div>
  </div>
</template>

<script>
import AnalyzeItem from "./analyze-item";
import { getAnalyzes } from "@/api/stat";
export default {
  data() {
    return {
      analyzeData: []
    };
  },
  mounted() {
    this.getAnalyzes();
  },
  methods: {
    getAnalyzes() {
      getAnalyzes(this.$route.params.id)
        .then(res => {
          this.analyzeData = Object.values(res);
        })
        .catch(() => {
          this.analyzeData = [];
        });
    }
  },
  components: {
    AnalyzeItem
  }
};
</script>

<style lang="less" scoped>
.nodata {
  text-align: center;
  color: #909399;
}
</style>